import { default as ProgressBar } from './progress-bar'
export * from './progress-bar'

export default ProgressBar
